import { FunctionComponent, lazy } from 'react';

/*
 Component decorator that converts a Component that takes TProps 
 into a lazy component that takes a promise for TProps

 this may have very strange interactions with child components or re-renders so use sparingly.
*/
export function lazify<TPropType>(Component: FunctionComponent<TPropType>) {
  return function (propsPromise: PromiseLike<TPropType>) {
    return lazy(async function () {
      // TODO(nibeauli): handle failure!
      const props = (await propsPromise) as TPropType;
      return {
        // Using the function syntax because JSX transformer is incorrectly uptyping this to a component instead of an FC (I think)
        default: () => Component(props),
      };
    });
  };
}
